import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import {CloseButton} from "react-bootstrap";

const MapitalyModal = (props) => {
    const { modalTitle, modalText, confirmText, cancelText, show, handleClose, handleHide, handleConfirm, handleCancel } = props;
    const handleCloseModal = (type) => {
        handleClose();
        switch (type) {
            case 'confirm':
                if (handleConfirm) {
                    handleConfirm();
                }
                break;
            case 'cancel':
                if (handleCancel) {
                    handleCancel();
                }
                break;
            case 'hide':
            default:
                if (handleHide) {
                    handleHide();
                }
        }
    }
    return (
        <>
            <Modal show={show} onHide={() => handleCloseModal('hide')} centered>
                {modalTitle && <Modal.Header closeButton>
                                <Modal.Title>{modalTitle}</Modal.Title>
                            </Modal.Header>}
                <Modal.Body>
                    {modalText}
                    {!modalTitle && <CloseButton style={{float: "right"}} onClick={() => handleCloseModal('hide')} />}</Modal.Body>
                {(confirmText ||cancelText) && <Modal.Footer>
                    {confirmText && <Button variant="primary" onClick={() => handleCloseModal('confirm')}>
                                        {confirmText}
                                    </Button>}
                    {cancelText && <Button variant="secondary" onClick={() => handleCloseModal('cancel')}>
                                        {cancelText}
                                    </Button>}
                </Modal.Footer>}
            </Modal>
        </>
    );
}

export default MapitalyModal;
